import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import ManufacturerTable from '../components/ManufacturerTable';

const ManufacturerList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Manufacturers</span>
      </Portal>
      {pageSize && <ManufacturerTable />}
    </Card>
  );
};

export default ManufacturerList;
